import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const GET_EQUIPMENTSEPI = "GET_EQUIPMENTSEPI";
export const GET_COWORKERS_EQUIPMENTSEPI = "GET_COWORKERS_EQUIPMENTSEPI";
export const GET_COMMON_AND_UNAFFECTED_EQUIPMENTS = "GET_COMMON_AND_UNAFFECTED_EQUIPMENTS";
export const SET_EPI_FILTERS = "SET_EPI_FILTERS";
export const SET_CURRENT_EQUIPMENTEPI = "SET_CURRENT_EQUIPMENTEPI";
export const SET_CURRENT_EQUIPMENTEPI_FORM = "SET_CURRENT_EQUIPMENTEPI_FORM";
export const SET_CURRENT_EQUIPMENT_INPSECTION = "SET_CURRENT_EQUIPMENT_INPSECTION";
export const SET_EQUIPMENTEPI_FORM_SECTIONS = "SET_EQUIPMENTEPI_FORM_SECTIONS";
export const SET_EQUIPMENTS_EPI_TAB_ID = "SET_EQUIPMENTS_EPI_TAB_ID";
export const SET_NB_EPI_TO_CHECK = "SET_NB_EPI_TO_CHECK";
export const SET_EPICATEGORIES = "SET_EPICATEGORIES";

export const MY_EQUIPMENTS_EPI = "MY_EQUIPMENTS_EPI";
export const COWORKERS_EQUIPMENTS_EPI = "COWORKERS_EQUIPMENTS_EPI";
export const SET_EQUIPMENTS_EPI_INDEX = "SET_EQUIPMENTS_EPI_INDEX";
export const SET_EPI_FILTERED_LIST = "SET_EPI_FILTERED_LIST";
